export enum SchoolPlatformEnum {
  LIV = 1,
  MY_WORLD = 2
}
